import { render, staticRenderFns } from "./ETPOffer.vue?vue&type=template&id=52ce97e2&scoped=true&"
import script from "./ETPOffer.vue?vue&type=script&lang=ts&"
export * from "./ETPOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce97e2",
  null
  
)

export default component.exports